<app-flow-action-card icon="music_note" iconColor="text-purple-600" label="Audio">
  <span
    class="truncate block"
    [matTooltip]="data().value.label"
    [matTooltipPosition]="'after'"
    >{{ data().value.label }}</span
  >
</app-flow-action-card>
